const idealSetup = {
  settingNames: {
    patientDiscount: "Patient Discount",
    catalogAndQualityProgram: "Catalog and Quality Program",
    globalPromotions: "Global Promotions",
    openCatalog: "Open Catalog",
  },
  booleanValues: {
    on: "On",
    off: "Off",
  },
  optOut: {
    title: "This change will turn off recommended practice settings",
    description:
      "Your practice currently has the recommended settings applied, which includes free standard shipping on first treatment plan orders.",
    recommendedSettingsLabel: "Recommended settings",
    changingSettingText: "The update to {{settingName}} does not meet program requirements.",
    settingsChecklist: {
      firstOrderDiscount: "First order discount: {{value}}%",
      autoshipDiscount: "Auto refill discount: {{value}}%",
      practiceDiscount: "Practice discount: {{value}}%",
      globalPromotionOptIn: "Opt-in to promotions",
      globalPromotionDiscount: "Promotion discount: {{value}}%",
      catalogPermission: "Open catalog",
      isTopPickEnabled: "Display top picks",
      isEnhancedTestingEnabled: "Display enhanced testing",
    },
    consequences: {
      title: "What this means:",
      freeShipping: "Free standard shipping on first treatment plan orders will be removed",
      settings: "Your practice will no longer have the recommended settings applied",
      reEnroll: "You can re-enroll in recommended settings at any time from the banner",
    },
    updateNote: "Only {{settingName}} will be updated. All other settings will remain unchanged.",
    cancelButton: "Cancel",
    confirmButton: "Update settings",
  },
} as const;

export { idealSetup };
